module.exports = __webpack_public_path__ + "img/R6__0818.8921fb5f.jpg";